import { render, staticRenderFns } from "./AutoType.vue?vue&type=template&id=14a75a8a&scoped=true&"
import script from "./AutoType.vue?vue&type=script&lang=js&"
export * from "./AutoType.vue?vue&type=script&lang=js&"
import style0 from "./AutoType.vue?vue&type=style&index=0&id=14a75a8a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a75a8a",
  null
  
)

export default component.exports